import { useState, useEffect } from 'react'
import { nameUrlPair } from '../interfaces/definitions/nameUrlPair-interface'
import fetchNameUrls, { ImageData } from '../services/fetchNameUrls'

function useImg (imgNames: ImageData[]): [nameUrlPair[], string] {
  const [urlArray, setUrlArray] = useState<nameUrlPair[]>([])
  const [error, setError] = useState<string>('')

  const fetchedUrl = async (imgNames: ImageData[]): Promise<void> => {
    try {
      setError('')
      const nameUrl = await fetchNameUrls(imgNames)
      setUrlArray(nameUrl)
    } catch (error) {
      setError(error as string)
    }
  }

  useEffect(() => {
    fetchedUrl(imgNames).then(() => { }).catch(error => {
      setError(error as string)
    })
  }, [imgNames])

  return [urlArray, error]
}

export default useImg
